import { Doughnut } from 'vue-chartjs'
import { chartMixin } from './NewchartMixin'

export default {
  extends: Doughnut,
  mixins: [chartMixin],
}
